module.exports = __webpack_public_path__ + "img/estoque.0be8b144.svg";